export const Types = {
  GET_SECTOR_TYPES_REQUESTED: 'types/GET_SECTOR_TYPES_REQUESTED',
  GET_SECTOR_TYPES_SUCCEEDED: 'types/GET_SECTOR_TYPES_SUCCEEDED',
  GET_SECTOR_TYPES_FAILED: 'types/GET_SECTOR_TYPES_FAILED',

  GET_DEPARTMENT_TYPES_REQUESTED: 'types/GET_DEPARTMENT_TYPES_REQUESTED',
  GET_DEPARTMENT_TYPES_SUCCEEDED: 'types/GET_DEPARTMENT_TYPES_SUCCEEDED',
  GET_DEPARTMENT_TYPES_FAILED: 'types/GET_DEPARTMENT_TYPES_FAILED',

  GET_DOCUMENT_TYPES_REQUESTED: 'types/GET_DOCUMENT_TYPES_REQUESTED',
  GET_DOCUMENT_TYPES_SUCCEEDED: 'types/GET_DOCUMENT_TYPES_SUCCEEDED',
  GET_DOCUMENT_TYPES_FAILED: 'types/GET_DOCUMENT_TYPES_FAILED',

  GET_CITY_TYPES_REQUESTED: 'types/GET_CITY_TYPES_REQUESTED',
  GET_CITY_TYPES_SUCCEEDED: 'types/GET_CITY_TYPES_SUCCEEDED',
  GET_CITY_TYPES_FAILED: 'types/GET_CITY_TYPES_FAILED',

  GET_GENDER_TYPES_REQUESTED: 'types/GET_GENDER_TYPES_REQUESTED',
  GET_GENDER_TYPES_SUCCEEDED: 'types/GET_GENDER_TYPES_SUCCEEDED',
  GET_GENDER_TYPES_FAILED: 'types/GET_GENDER_TYPES_FAILED',

  GET_MARITAL_STATUS_TYPES_REQUESTED: 'types/GET_MARITAL_STATUS_TYPES_REQUESTED',
  GET_MARITAL_STATUS_TYPES_SUCCEEDED: 'types/GET_MARITAL_STATUS_TYPES_SUCCEEDED',
  GET_MARITAL_STATUS_TYPES_FAILED: 'types/GET_MARITAL_STATUS_TYPES_FAILED',

  GET_BLOOD_TYPES_REQUESTED: 'types/GET_BLOOD_TYPES_REQUESTED',
  GET_BLOOD_TYPES_SUCCEEDED: 'types/GET_BLOOD_TYPES_SUCCEEDED',
  GET_BLOOD_TYPES_FAILED: 'types/GET_BLOOD_TYPES_FAILED',

  GET_STATE_TYPES_REQUESTED: 'types/GET_STATE_TYPES_REQUESTED',
  GET_STATE_TYPES_SUCCEEDED: 'types/GET_STATE_TYPES_SUCCEEDED',
  GET_STATE_TYPES_FAILED: 'types/GET_STATE_TYPES_FAILED',

  GET_LANGUAGE_TYPES_REQUESTED: 'types/GET_LANGUAGE_TYPES_REQUESTED',
  GET_LANGUAGE_TYPES_SUCCEEDED: 'types/GET_LANGUAGE_TYPES_SUCCEEDED',
  GET_LANGUAGE_TYPES_FAILED: 'types/GET_LANGUAGE_TYPES_FAILED',

  GET_COMPANY_SEGMENT_TYPES_REQUESTED: 'types/GET_COMPANY_SEGMENT_TYPES_REQUESTED',
  GET_COMPANY_SEGMENT_TYPES_SUCCEEDED: 'types/GET_COMPANY_SEGMENT_TYPES_SUCCEEDED',
  GET_COMPANY_SEGMENT_TYPES_FAILED: 'types/GET_COMPANY_SEGMENT_TYPES_FAILED',

  GET_SERVICE_GROUP_TYPES_REQUESTED: 'types/GET_SERVICE_GROUP_TYPES_REQUESTED',
  GET_SERVICE_GROUP_TYPES_SUCCEEDED: 'types/GET_SERVICE_GROUP_TYPES_SUCCEEDED',
  GET_SERVICE_GROUP_TYPES_FAILED: 'types/GET_SERVICE_GROUP_TYPES_FAILED',

  GET_REVENUE_TYPES_REQUESTED: 'types/GET_REVENUE_TYPES_REQUESTED',
  GET_REVENUE_TYPES_SUCCEEDED: 'types/GET_REVENUE_TYPES_SUCCEEDED',
  GET_REVENUE_TYPES_FAILED: 'types/GET_RENENUE_TYPES_FAILED',
}

export function getSectorTypes() {
  return {
    type: Types.GET_SECTOR_TYPES_REQUESTED,
  }
}

export function getDepartmentTypes() {
  return {
    type: Types.GET_DEPARTMENT_TYPES_REQUESTED,
  }
}

export function getDocumentTypes() {
  return {
    type: Types.GET_DOCUMENT_TYPES_REQUESTED,
  }
}

export function getCityTypes() {
  return {
    type: Types.GET_CITY_TYPES_REQUESTED,
  }
}

export function getGenderTypes() {
  return {
    type: Types.GET_GENDER_TYPES_REQUESTED,
  }
}

export function getMaritalStatusTypes() {
  return {
    type: Types.GET_MARITAL_STATUS_TYPES_REQUESTED,
  }
}

export function getBloodTypes() {
  return {
    type: Types.GET_BLOOD_TYPES_REQUESTED,
  }
}

export function getStateTypes() {
  return {
    type: Types.GET_STATE_TYPES_REQUESTED,
  }
}

export function getLanguageTypes() {
  return {
    type: Types.GET_LANGUAGE_TYPES_REQUESTED,
  }
}

export function getCompanySegmentTypes() {
  return {
    type: Types.GET_COMPANY_SEGMENT_TYPES_REQUESTED,
  }
}

export function getServiceGroupTypes() {
  return {
    type: Types.GET_SERVICE_GROUP_TYPES_REQUESTED,
  }
}

export function getRevenueTypes() {
  return {
    type: Types.GET_REVENUE_TYPES_REQUESTED,
  }
}

const INITIAL_STATE = {
  getSectorTypesIsLoading: false,
  getSectorTypesError: null,
  sectorTypes: [],

  getDepartmentTypesIsLoading: false,
  getDepartmentTypesError: null,
  departmentTypes: [],

  getDocumentTypesIsLoading: false,
  getDocumentTypesError: null,
  documentTypes: [],

  getCityTypesIsLoading: false,
  getCityTypesError: null,
  cityTypes: [],

  getGenderTypesIsLoading: false,
  getGenderTypesError: null,
  genderTypes: [],

  getMaritalStatusTypesIsLoading: false,
  getMaritalStatusTypesError: null,
  maritalStatusTypes: [],

  getBloodTypesIsLoading: false,
  getBloodTypesError: null,
  bloodTypes: [],

  getStateTypesIsLoading: false,
  getStateTypesError: null,
  stateTypes: [],

  getLanguageTypesIsLoading: false,
  getLanguageTypesError: null,
  languageTypes: [],

  getCompanySegmentTypesIsLoading: false,
  getCompanySegmentTypesError: null,
  companySegmentTypes: [],

  getServiceGroupTypesIsLoading: false,
  getServiceGroupTypesError: null,
  serviceGroupTypes: [],

  getRevenueTypesIsLoading: false,
  getRevenueTypesError: null,
  revenueTypes: [],
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_SECTOR_TYPES_REQUESTED:
      return {
        ...state,
        getSectorTypesIsLoading: true,
      }
    case Types.GET_SECTOR_TYPES_SUCCEEDED:
      return {
        ...state,
        getSectorTypesIsLoading: false,
        getSectorTypesError: null,
        sectorTypes: action.payload,
      }
    case Types.GET_SECTOR_TYPES_FAILED:
      return {
        ...state,
        getSectorTypesIsLoading: false,
        getSectorTypesError: action.payload,
        sectorTypes: [],
      }

    case Types.GET_DEPARTMENT_TYPES_REQUESTED:
      return {
        ...state,
        getDeparmentTypesIsLoading: true,
      }
    case Types.GET_DEPARTMENT_TYPES_SUCCEEDED:
      return {
        ...state,
        getDeparmentTypesIsLoading: false,
        getDeparmentTypesError: null,
        departmentTypes: action.payload,
      }
    case Types.GET_DEPARTMENT_TYPES_FAILED:
      return {
        ...state,
        getDeparmentTypesIsLoading: false,
        getDeparmentTypesError: action.payload,
        departmentTypes: [],
      }

    case Types.GET_DOCUMENT_TYPES_REQUESTED:
      return {
        ...state,
        getDocumentTypesIsLoading: true,
      }
    case Types.GET_DOCUMENT_TYPES_SUCCEEDED:
      return {
        ...state,
        getDocumentTypesIsLoading: false,
        getDocumentTypesError: null,
        documentTypes: action.payload,
      }
    case Types.GET_DOCUMENT_TYPES_FAILED:
      return {
        ...state,
        getDocumentTypesIsLoading: false,
        getDocumentTypesError: action.payload,
        documentTypes: [],
      }

    case Types.GET_CITY_TYPES_REQUESTED:
      return {
        ...state,
        getCityTypesIsLoading: true,
      }
    case Types.GET_CITY_TYPES_SUCCEEDED:
      return {
        ...state,
        getCityTypesIsLoading: false,
        getCityTypesError: null,
        cityTypes: action.payload,
      }
    case Types.GET_CITY_TYPES_FAILED:
      return {
        ...state,
        getCityTypesIsLoading: false,
        getCityTypesError: action.payload,
        cityTypes: [],
      }

    case Types.GET_GENDER_TYPES_REQUESTED:
      return {
        ...state,
        getGenderTypesIsLoading: true,
      }
    case Types.GET_GENDER_TYPES_SUCCEEDED:
      return {
        ...state,
        getGenderTypesIsLoading: false,
        getGenderTypesError: null,
        genderTypes: action.payload,
      }
    case Types.GET_GENDER_TYPES_FAILED:
      return {
        ...state,
        getGenderTypesIsLoading: false,
        getGenderTypesError: action.payload,
        genderTypes: [],
      }

    case Types.GET_MARITAL_STATUS_TYPES_REQUESTED:
      return {
        ...state,
        getMaritalStatusTypesIsLoading: true,
      }
    case Types.GET_MARITAL_STATUS_TYPES_SUCCEEDED:
      return {
        ...state,
        getMaritalStatusTypesIsLoading: false,
        getMaritalStatusTypesError: null,
        maritalStatusTypes: action.payload,
      }
    case Types.GET_MARITAL_STATUS_TYPES_FAILED:
      return {
        ...state,
        getMaritalStatusTypesIsLoading: false,
        getMaritalStatusTypesError: action.payload,
        maritalStatusTypes: [],
      }

    case Types.GET_BLOOD_TYPES_REQUESTED:
      return {
        ...state,
        getBloodTypesIsLoading: true,
      }
    case Types.GET_BLOOD_TYPES_SUCCEEDED:
      return {
        ...state,
        getBloodTypesIsLoading: false,
        getBloodTypesError: null,
        bloodTypes: action.payload,
      }
    case Types.GET_BLOOD_TYPES_FAILED:
      return {
        ...state,
        getBloodTypesIsLoading: false,
        getBloodTypesError: action.payload,
        bloodTypes: [],
      }

    case Types.GET_STATE_TYPES_REQUESTED:
      return {
        ...state,
        getStateTypesIsLoading: true,
      }
    case Types.GET_STATE_TYPES_SUCCEEDED:
      return {
        ...state,
        getStateTypesIsLoading: false,
        getStateTypesError: null,
        stateTypes: action.payload,
      }
    case Types.GET_STATE_TYPES_FAILED:
      return {
        ...state,
        getStateTypesIsLoading: false,
        getStateTypesError: action.payload,
        stateTypes: [],
      }

    case Types.GET_LANGUAGE_TYPES_REQUESTED:
      return {
        ...state,
        getLanguageTypesIsLoading: true,
      }
    case Types.GET_LANGUAGE_TYPES_SUCCEEDED:
      return {
        ...state,
        getLanguageTypesIsLoading: false,
        getLanguageTypesError: null,
        languageTypes: action.payload,
      }
    case Types.GET_LANGUAGE_TYPES_FAILED:
      return {
        ...state,
        getLanguageTypesIsLoading: false,
        getLanguageTypesError: action.payload,
        languageTypes: [],
      }

    case Types.GET_COMPANY_SEGMENT_TYPES_REQUESTED:
      return {
        ...state,
        getCompanySegmentTypesIsLoading: true,
      }
    case Types.GET_COMPANY_SEGMENT_TYPES_SUCCEEDED:
      return {
        ...state,
        getCompanySegmentTypesIsLoading: false,
        getCompanySegmentTypesError: null,
        companySegmentTypes: action.payload,
      }
    case Types.GET_COMPANY_SEGMENT_TYPES_FAILED:
      return {
        ...state,
        getCompanySegmentTypesIsLoading: false,
        getCompanySegmentTypesError: action.payload,
        companySegmentTypes: [],
      }

    case Types.GET_SERVICE_GROUP_TYPES_REQUESTED:
      return {
        ...state,
        getServiceGroupTypesIsLoading: true,
      }
    case Types.GET_SERVICE_GROUP_TYPES_SUCCEEDED:
      return {
        ...state,
        getServiceGroupTypesIsLoading: false,
        getServiceGroupTypesError: null,
        serviceGroupTypes: action.payload,
      }
    case Types.GET_SERVICE_GROUP_TYPES_FAILED:
      return {
        ...state,
        getServiceGroupTypesIsLoading: false,
        getServiceGroupTypesError: action.payload,
        serviceGroupTypes: [],
      }

    case Types.GET_REVENUE_TYPES_REQUESTED:
      return {
        ...state,
        getRevenueTypesIsLoading: true,
      }
    case Types.GET_REVENUE_TYPES_SUCCEEDED:
      return {
        ...state,
        getRevenueTypesIsLoading: false,
        getRevenueTypesError: null,
        revenueTypes: action.payload,
      }
    case Types.GET_REVENUE_TYPES_FAILED:
      return {
        ...state,
        getRevenueTypesIsLoading: false,
        getRevenueTypesError: action.payload,
        revenueTypes: [],
      }

    default:
      return state
  }
}
